<template>
  <div id="app">
    <el-container>
      <el-main>
        <el-form ref="form" :model="form" label-position="top" size="small" >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="时间：">
                <el-date-picker type="datetime" v-model="form.time" disabled />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="类型:">
                <el-input v-model="form.type === '0' ? '建议' : '投诉'" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="门店：">
                <el-input v-model="form.storeName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item v-if="form.type === '1'" label="投诉区域：">
                <el-input v-model="form.region" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
              <el-form-item label="手机号：">
                <el-input v-model="form.phone" disabled></el-input>
              </el-form-item>
            </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
                  <el-form-item label="投诉人姓名：">
                      <el-input v-model="form.name" disabled></el-input>
                  </el-form-item>
              </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="24" :xl="24">
              <el-form-item v-if="form.type === '1'" label="投诉内容：">
                <el-input type="textarea" v-model="form.matters" disabled :rows="10" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="24" :xl="24">
              <el-form-item v-if="form.type === '0'" label="建议：">
                <el-input type="textarea" v-model="form.suggestion" disabled :rows="10" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="24" :xl="24">
              <el-form-item v-if="form.type === '1'"  label="投诉图片：">
                <el-image v-for="(image,i) in form.images" :key="i"
                          style="width: 300px; height: 200px; border:none;cursor: pointer; padding: 20px"
                          :src="getImage(image.imageName)"
                          :preview-src-list="[`${baseURL}/download?name=${image.imageName}`]"
                >
                </el-image>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="24" :xl="24">
              <el-form-item label="回复内容">
                <el-input type="textarea" v-model="form.replyResult" :rows="10" :maxlength="2000"
                          show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="24" :xl="24">
              <el-form-item label="是否展示">
                <el-switch v-model="form.isDisplay"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-main>
      <el-footer>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button type="primary" @click="handleClose">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  props: {
    id: {type: String},
  },
  name: 'App',
  data() {
    return {
      form: {},
      baseURL: this.$http.defaults.baseURL
    }
  },
  created() {
    this.getComplaintInfo()
  },
  methods: {
    getComplaintInfo() {
      this.$http.get(`/complaint/${this.id}`).then(res => {
        if (String (res.code) === '1'){
          this.form = res.data
        }
      }).catch(()=>{
        return this.$message.error("系统繁忙请稍后，请稍后再试！")
      })
    },
    async onSubmit() {
      this.form.complaintId = this.complaintId
      await this.$http.put('/complaint', this.form).then(res=>{
        if(String (res.code) === '1'){
          this.handleClose()
          return this.$message.success("保存成功")
      }
      })
    },
    getImage(image) {
      return `${this.baseURL}/download?name=${image}`
    },
    handleClose() {
      this.$emit("handleClose")
    }
  },
}
</script>

<style>
.el-container {
  height: 100%;
  background: #fff;
}

.el-header, .el-footer {
  line-height: 60px;
  background: #fff;
  text-align: center;
}

.el-main {
  padding: 20px;
}

.el-descriptions-item__cell {
  padding: 12px;
}

.el-divider--horizontal {
  margin: 0;
}

.el-result {
  padding: 0;
}

.divider {
  background-color: #157EFB;
  height: 5px;
  border-radius: 5px;
}

.el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 0;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}

.el-input.is-disabled .el-input__inner {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/ComplaintHandle.vue